import ReturnService from "./components/return-service/return-service";
import PageWrapper from "../wrappers/page-wrapper";

ReturnService.domainName = "return-service";

export default PageWrapper(ReturnService);
